import { IRowNode } from "ag-grid-community";
import { DateFormat, formatDate } from "common";
import { RowData } from "./types";

export const purchaseDateCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data) {
        return null;
    }

    const { createdAt } = data.item.purchase;

    return createdAt ? createdAt : null;
};

export const PurchaseDateCellFormatter = ({ data }: { data: RowData }) => {
    if ("balance" in data || !data.isOrganizer) {
        return "";
    }

    const { createdAt } = data.item.purchase;

    const purchaseDate = formatDate(createdAt, DateFormat.DATE_SHORT, true);

    return purchaseDate;
};

export const dateComparator = (date1: string | null, date2: string | null, node1: IRowNode, node2: IRowNode) => {
    // Check if the nodes are the first rows
    const isFirstRow1 = node1.rowIndex === 0;
    const isFirstRow2 = node2.rowIndex === 0;

    // If either node is the first row, keep it at the top regardless of sorting
    if (isFirstRow1 || isFirstRow2) {
        return 0;
    }

    const dateNumber1: number | null = date1 ? Date.parse(date1) : null;
    const dateNumber2: number | null = date2 ? Date.parse(date2) : null;

    if (dateNumber1 === null && dateNumber2 === null) {
        return 0;
    }

    if (dateNumber1 === null) {
        return -1;
    }

    if (dateNumber2 === null) {
        return 1;
    }

    return dateNumber1 - dateNumber2;
};
